jQuery(document).ready(function(){

    if (window.location.href.indexOf("/blogs/growing-guides") > -1) {
        
        if(window.location.hash.indexOf("blog-link-herb") > -1 ){

            $('.herb-tab').click();
            $('#collapse-tab1').removeClass('in active')
            $('#collapse-tab2').addClass('in active')

        }

        if(window.location.hash.indexOf("blog-link-monthly") > -1 ){

            $('.monthly-tab').click();
            $('#collapse-tab1').removeClass('in active')
            $('#collapse-tab3').addClass('in active')

        }
        
        if(window.location.hash.indexOf("blog-link-rekha") > -1 ){

            $('.rebha-tab').click();
            $('#collapse-tab1').removeClass('in active')
            $('#collapse-tab4').addClass('in active')

        }
        
        if(window.location.hash.indexOf("blog-link-sow-easy") > -1 ){

            $('.sow-easy-tab').click();
            $('#collapse-tab1').removeClass('in active')
            $('#collapse-tab5').addClass('in active')
        }
    }
    
    lazyload();



    jQuery('#myTab a').click(function () {
        jQuery(this).tab('show');
    })



    jQuery(document).on('click' , '.yotpo-display-wrapper' , function(e){
        e.preventDefault()

        jQuery('.Reviewtab').siblings().removeClass('active');
        jQuery('.Reviewtab').addClass('active');
        jQuery('#myTabContent div').removeClass('active');
        jQuery('#collapse-tab4').tab('show');
        jQuery('#collapse-tab4').addClass('active');
        jQuery('#collapse-tab4').addClass('in');
    });





    jQuery(document).on('click' , '.main-content' , function(){
        if (jQuery(".gf-menu-device-wrapper").hasClass("active")){
            jQuery('.gf-menu-device-wrapper').click();
        }
    });
    jQuery(document).on('click' , '.header' , function(){
        if (jQuery(".gf-menu-device-wrapper").hasClass("active")){
            jQuery('.gf-menu-device-wrapper').click();
        }
    });

    /*jQuery('span.money').replaceWith(function(){
        return '<p class="money">' + $(this).html() + '</p>';
    });*/


    var seeds_label = $("#collapse-tab1 td[width='25%']").html();
    var seeds_count = $("#collapse-tab1 td[width='75%']").html();
    var data_variant = $(".short-description").attr("variant");
    var data_collectionbox = $(".short-description").attr("collectionbox");

    $('[data-variant]').each(function() {
      if ($(this).data('variant') !== 'has_variant') {
        if ($(this).data('collectionbox') !== 'is_collectionbox') {
            if( seeds_label != ''){

                if (typeof seeds_label  !== 'undefined' && typeof seeds_count  !== 'undefined' ) {
                    var seedsDiv = $("<div class='seeds-count'> " + seeds_label + " " + seeds_count + "</div>");
                    $('.short-description').append(seedsDiv);
                }
            }
        };
      };
    })
    
    //this looks to see if the growing guide page has a tagged  in the url had to be done in jQuery as liquid couldnt see the /tagged 
    var url = $(location).attr('href');
    var taggedvalue = "/blogs/growing-guides/tagged";
    if(url.indexOf(taggedvalue) != -1){
        $('.nav-tabs').hide();
        $('.tab-pane').show();
        $('.tab-pane').addClass('active in');
    }


    jQuery(document).on('click' , '.blog-link' , function(e){

        let newUrl = window.location.href.replace( window.location.search, '' ).replace( window.location.hash, '' );
        window.history.pushState( "", "", newUrl );



        var classList = $(this).attr("class");
        classList = classList.replace(/\s+/g, '-').toLowerCase();
        console.log(classList);
        var urls = document.location.href+"#"+classList;
        document.location = urls;



    });



    


});